import React, { useState } from 'react';

import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';

import * as ST from './styled';

export interface IEquipPreview {
    images?: string[],
}

const EquipmentImages = ({
    images = [],
} : IEquipPreview): JSX.Element | null => {
    const imagesCount = images?.length || 0;
    const [selectedImageIdx, setSelectedImageIdx] = useState(0);

    if (!imagesCount) {
        return null;
    }

    return (
        <FullWidthListContainer $size={16}>
            <ST.ImageDisplay>
                <img src={images[selectedImageIdx]} alt='Продукт'/>
            </ST.ImageDisplay>
            {imagesCount > 1 &&
                <FullWidthListContainer $desktop={24} $mobile={20}>
                    {images.map((image, idx) => (
                        <ST.ImageItem
                            key={idx}
                            onClick={() => setSelectedImageIdx(idx)}
                            isSelected={selectedImageIdx === idx}
                        >
                            <img src={image} alt={`Картинка продукта ${idx}`}/>
                        </ST.ImageItem>
                    ))}
                </FullWidthListContainer>
            }
        </FullWidthListContainer>
    );
};

export default React.memo(EquipmentImages);
